<script setup lang="ts">
definePageMeta({
  name: "search",
  title: "Søk",
  layout: "search",
})

const route = useRoute<"search">()
const { loading, results, totalCounts, filteredCounts, loadMore } = useContentSearch()
const productVariants = useProductVariantsStore()

const productLink = computed(() => `/produkter/${route.params.product}/${route.params.variant}`)
</script>

<template>
  <div class="min-h-dvh font-national2 text-white">
    <div
      class="mb-6 grid grid-cols-1 gap-6 lg:mb-12 lg:grid-cols-16"
    >
      <div class="hidden lg:col-span-4 lg:block">
        <ULogo :dark="false" :product="productVariants.activeProduct" />
      </div>
      <header class="col-span-1 lg:col-span-11 lg:col-start-6 lg:grid lg:grid-cols-subgrid">
        <div class="col-span-full mb-8 flex items-center justify-between lg:mb-10">
          <h2
            class="font-national2condensed text-paywall-mobile-title md:text-paywall-desktop-title"
          >
            Søk
            <span class="sr-only">i {{ productVariants.activeProduct?.productTitle }}</span>
          </h2>
          <UButton
            size="xs"
            circle
            variant="quite"
            :aria-label="`Lukk søk og gå tilbake til hovedsiden til ${productVariants.activeProduct?.productTitle}`"
            :to="productLink"
            class="!p-0 text-white"
          >
            <template #prepend>
              <UIcon
                name="close"
                class="rounded-full border-2 border-white p-2 hover:border-u-contrast"
              />
            </template>
          </UButton>
        </div>
        <USearchBar variant="light" class="lg:col-span-10" />
      </header>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-16">
      <SearchFilters
        class="w-full lg:col-span-4"
        role="search"
        aria-label="Filter"
      />
      <main class="mb-8 w-full lg:col-span-10 lg:col-start-6">
        <div
          v-if="loading && results.data.length === 0"
          class="flex flex-col items-center justify-center py-16"
        >
          <UBookLoader />
          <p class="mt-5 font-national2 text-2xl text-white">
            Laster inn...
          </p>
        </div>
        <USearchResultsList
          v-else
          :loading="loading"
          :results="results.data"
          :total-counts="totalCounts"
          :filtered-counts="filteredCounts"
          @load-more="loadMore"
        />
      </main>
    </div>
  </div>
</template>
